import styled from 'styled-components';

import {flexSpace} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';

const QuantityContainer = styled.div`
  ${flexSpace}
  width: 16px;
  font-weight: normal;
  ${flipOnLTR`
    margin-left: 5px;
  `}
`;

type QuantityProps = {
  children?: React.ReactNode;
  className?: string;
};

const Quantity = ({children, className}: QuantityProps = {}) => {
  if (!children) {
    return null;
  }
  return <QuantityContainer className={className}>{children}</QuantityContainer>;
};

export default Quantity;
